const START_CATEGORY_NAMES = [
  ['уральская кухня'],
  ['салаты'],
  ['супы'],
  ['закуски'],
  ['горячие блюда'],
  ['японское меню'],
  ['пицца 30 см'],
  ['пицца 40 см'],
  ['пироги'],
];

const END_CATEGORY_NAMES = [
  ['детское меню'],
  ['десерты'],
];

const normalizeCategoryName = (name = '') =>
  name.trim().toLowerCase().replace(/\s+/g, ' ');

const findCategoryIndex = (name = '', categoryNames = []) => {
  const normalizedName = normalizeCategoryName(name);

  return categoryNames.findIndex((variants) =>
    variants.some((variant) => normalizedName === normalizeCategoryName(variant))
  );
};

const getCategorySortMeta = (name = '') => {
  const startIndex = findCategoryIndex(name, START_CATEGORY_NAMES);
  if (startIndex !== -1) {
    return { bucket: 0, order: startIndex };
  }

  const endIndex = findCategoryIndex(name, END_CATEGORY_NAMES);
  if (endIndex !== -1) {
    return { bucket: 2, order: endIndex };
  }

  return { bucket: 1, order: 0 };
};

export const sortMenuGroups = (groups = []) =>
  [...groups].sort((a, b) => {
    const aMeta = getCategorySortMeta(a.name);
    const bMeta = getCategorySortMeta(b.name);
    const bucketDiff = aMeta.bucket - bMeta.bucket;

    if (bucketDiff !== 0) {
      return bucketDiff;
    }

    const orderDiff = aMeta.order - bMeta.order;
    if (orderDiff !== 0) {
      return orderDiff;
    }

    return 0;
  });
